module.exports = __webpack_public_path__ + "assets/b118.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b118.png
// module id = 590
// module chunks = 0